/**
 * MiauLand Gratis-Geschenk
 * Legt ab GIFT_THRESHOLD (in Cent) automatisch das Geschenk-Produkt in den
 * Warenkorb und entfernt es wieder, wenn der Bestellwert darunter fällt.
 */

/* ==== KONFIG HIER ANPASSEN ==== */
const GIFT_VARIANT_ID = 58497144815941; // Variante des Produkts „Geschenk“
const GIFT_THRESHOLD = 9900; // in Cent (99 €) – muss zu snippets/cart-progress-bar.liquid passen
/* ============================== */

const SOURCE = 'free-gift-sync';
let syncing = false;

async function syncFreeGift() {
  if (syncing) return;
  syncing = true;

  try {
    const cart = await fetch('/cart.js').then((r) => r.json());
    const giftLine = cart.items.find((item) => item.variant_id === GIFT_VARIANT_ID);
    const qualifies = cart.total_price >= GIFT_THRESHOLD;
    let changed = false;

    if (qualifies && !giftLine) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 }),
      });
      changed = res.ok;
    } else if (!qualifies && giftLine) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftLine.key, quantity: 0 }),
      });
      changed = true;
    } else if (giftLine && giftLine.quantity !== 1) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftLine.key, quantity: 1 }),
      });
      changed = true;
    }

    if (changed) {
      const newCart = await fetch('/cart.js').then((r) => r.json());
      const event = new Event('cart:update', { bubbles: true });
      event.detail = {
        resource: newCart,
        sourceId: SOURCE,
        data: { source: SOURCE, itemCount: newCart.item_count },
      };
      document.dispatchEvent(event);
    }
  } catch (error) {
    console.error('[free-gift]', error);
  } finally {
    syncing = false;
  }
}

document.addEventListener('cart:update', (event) => {
  if (event.detail?.data?.source === SOURCE) return;
  syncFreeGift();
});

document.addEventListener('discount:update', () => syncFreeGift());

syncFreeGift();
